export default __webpack_public_path__ + "static/media/54.9423f453.svg";